angular.module('shared').directive('autoFocus', ["$rootScope", "$timeout", function($rootScope, $timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var focusElement;
      focusElement = function() {
        return angular.element("[auto-focus]").focus();
      };
      $rootScope.$on('shared:autofocus:restart', function(event) {
        return focusElement();
      });
      return $timeout(function() {
        return focusElement();
      }, +attrs.autoFocus || 50);
    }
  };
}]);
